import React, { lazy } from 'react';
import { Clock, MapPin, Phone, Mail, Instagram } from 'lucide-react';
export function Footer() {
  return <footer id="ubicacion" className="bg-[#0A0A0A] pt-20 pb-10 border-t border-gold/20" data-id="element-88">
      <div className="container mx-auto px-6 md:px-12" data-id="element-89">
        <div className="flex justify-center mb-16" data-id="element-90">
          <img src="https://cdn.magicpatterns.com/uploads/3ADQKp1DHnDUdGH3xP27Pb/Onyx__Steel_Logo-Sin_fondo.png" alt="Onyx & Steel Logo" className="h-28 md:h-36 object-contain opacity-90" data-id="element-91" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-92">
          <div data-id="element-93">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase mb-6 font-medium flex items-center gap-2" data-id="element-94">
              <Clock className="w-4 h-4" data-id="element-95" /> Horarios
            </h4>
            <ul className="space-y-4 text-white/70 font-light text-sm" data-id="element-96">
              <li className="flex justify-between border-b border-white/5 pb-2" data-id="element-97">
                <span data-id="element-98">Lunes - Viernes</span>
                <span className="text-white" data-id="element-99">9:00 AM - 8:00 PM</span>
              </li>
              <li className="flex justify-between border-b border-white/5 pb-2" data-id="element-100">
                <span data-id="element-101">Sábados</span>
                <span className="text-white" data-id="element-102">8:00 AM - 6:00 PM</span>
              </li>
              <li className="flex justify-between border-b border-white/5 pb-2" data-id="element-103">
                <span data-id="element-104">Domingos</span>
                <span className="text-white" data-id="element-105">10:00 AM - 4:00 PM</span>
              </li>
            </ul>
          </div>

          <div data-id="element-106">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase mb-6 font-medium flex items-center gap-2" data-id="element-107">
              <Phone className="w-4 h-4" data-id="element-108" /> Contacto
            </h4>
            <ul className="space-y-4 text-white/70 font-light text-sm" data-id="element-109">
              <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer" data-id="element-110">
                <Phone className="w-4 h-4 text-gold/70" data-id="element-111" />
                (555) 123-4567
              </li>
              <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer" data-id="element-112">
                <Mail className="w-4 h-4 text-gold/70" data-id="element-113" />
                info@onyxandsteel.com
              </li>
              <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer" data-id="element-114">
                <Instagram className="w-4 h-4 text-gold/70" data-id="element-115" />
                @onyxandsteel
              </li>
            </ul>
          </div>

          <div data-id="element-116">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase mb-6 font-medium flex items-center gap-2" data-id="element-117">
              <MapPin className="w-4 h-4" data-id="element-118" /> Ubicación
            </h4>
            <p className="text-white/70 font-light text-sm leading-relaxed mb-6" data-id="element-119">
              123 Main Street, Suite 100
              <br data-id="element-120" />
              New York, NY 10001
              <span className="block mt-2 text-xs text-gold/70 italic" data-id="element-121">
                Estacionamiento gratuito disponible en la parte trasera.
              </span>
            </p>
            <div className="w-full h-40 rounded-2xl overflow-hidden border border-white/10 shadow-lg shadow-black/50" data-id="element-122">
              <iframe src="https://maps.google.com/maps?q=New%20York&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Onyx & Steel Location" className="grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-123"></iframe>
            </div>
          </div>
        </div>

        <div className="text-center border-t border-white/10 pt-8" data-id="element-124">
          <p className="text-white/40 text-xs font-light tracking-wider" data-id="element-125">
            © 2025 Onyx & Steel Barbershop. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}